import { useState, SyntheticEvent } from 'react';

import { TabContext, TabPanel } from '@mui/lab';

import Menu from 'components/views/Menu';
import NavTitle from 'components/views/NavTitle';
import Cancellation from 'components/views/Solicitation/Cancellation';
import TechnicalSupport from 'components/views/Solicitation/TechnicalSupport';
import CertificateOperation from 'components/views/Solicitation/CertificateOperation';
import OtherSolicitation from 'components/views/Solicitation/OtherSolicitation';
import { ContentBodyPage, ContentNewsPage } from 'components/views/ContainersPage';

import { ReactComponent as IcCancellation } from 'assets/icons/ic-cancellation.svg';
import { ReactComponent as IcTechnicalSupport } from 'assets/icons/ic-technical-support.svg';
import { ReactComponent as IcCertificateOperation } from 'assets/icons/ic-certificate-operation.svg';
import { ReactComponent as IcOtherSolicitation } from 'assets/icons/ic-other-solicitation.svg';

import BannerAppDesk from 'assets/images/banners/desk/banner-app-desk.png';

import { BoxBanner, TabCustom, BoxCustom, TabListCustom, BannerContent } from './styles';

const dataTab = [
    {
        text: 'Suporte técnico',
        value: '1',
        icon: <IcTechnicalSupport />
    },
    {
        text: 'Certificado de funcionamento',
        value: '2',
        icon: <IcCertificateOperation />
    },
    {
        text: 'Cancelamento',
        value: '3',
        icon: <IcCancellation />
    },
    {
        text: 'Demais Solicitações',
        value: '4',
        icon: <IcOtherSolicitation />
    }
];

const CustomerData = () => {
    const [value, setValue] = useState('1');

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <Menu titlePage='SOLICITAÇÕES'>
            <ContentBodyPage>
                <NavTitle title='Selecione um dos nossos atendimentos:' height='2.75rem' />
                <TabContext value={value}>
                    <BoxCustom>
                        <TabListCustom onChange={handleChange} aria-label="lab API tabs example">
                            {dataTab.map(({ text, value, icon }, index) =>
                                <TabCustom label={text} value={value} key={index} icon={icon} />
                            )}
                        </TabListCustom>
                    </BoxCustom>
                    {dataTab.map(({ value }, index) =>
                        <TabPanel value={value} key={index} sx={{ padding: '1.25rem 0 0' }}>
                            {value === '1' && <TechnicalSupport />}
                            {value === '2' && <CertificateOperation />}
                            {value === '3' && <Cancellation />}
                            {value === '4' && <OtherSolicitation />}
                        </TabPanel>
                    )}
                </TabContext>
            </ContentBodyPage>

            <ContentNewsPage>
                <BoxBanner>
                    <NavTitle title='Baixe o nosso APP' />
                    <BannerContent>
                        <img src={BannerAppDesk} alt="banner" />
                        {/* eslint-disable jsx-a11y/anchor-has-content */}
                        <a href="https://apps.apple.com/br/app/ituran-digital/id1486608545" className='apple' target='blank' />
                        <a href="https://play.google.com/store/search?q=ituran&c=apps" className='android' target='blank' />
                    </BannerContent>
                </BoxBanner>
            </ContentNewsPage>
        </Menu>
    );
}

export default CustomerData;